
<!-- appendToSelect -->
<nz-select appendToSelect [nzShowSearch]="csShowSearch" [nzLoading]="isLoading" [nzMode]="csMode" [nzAllowClear]="csAllowClear" [nzPlaceHolder]="csPlaceHolder | translate" class="w-100"
  [(ngModel)]="isObjectValue? controlValue?.value : controlValue" [nzNotFoundContent]="'BASE.NO_DATA_3' | translate" [nzDisabled]="csDisable" (nzOpenChange)="onOpenChange($event)"
  [nzMaxTagCount]="csMaxTagCount" [nzFilterOption]="filterOptionFn" (ngModelChange)="onModelChange($event)" [class]="css ? 'fixCss' : 'none'" [ngStyle]="{'width': cssWidth}"
  [vssUiMaxlengthInput]="256">
  <ng-container *ngIf="isGroup; else elseTemplate">
    <nz-option-group *ngFor="let item of csOption" [nzLabel]="item.label">
      <ng-container *ngFor="let child of item.children">
        <nz-option [nzValue]="isObjectValue? child : child.value" [nzLabel]="child.label" [nzDisabled]="child.disabled">
        </nz-option>
      </ng-container>
    </nz-option-group>
  </ng-container>
  <ng-template #elseTemplate>
    <ng-container *ngFor="let item of csOption">
      <nz-option [nzValue]="isObjectValue ? item : item.value" [nzLabel]="item.label" [nzDisabled]="item.disabled">
      </nz-option>
    </ng-container>
  </ng-template>
</nz-select>
